import React, { useState, useEffect, useRef } from 'react';
import { Space, Table, Button, Input, Spin, DatePicker, Col, Row, Statistic, Card, Typography } from 'antd';
import axios from 'axios';
import moment from 'moment';
import * as XLSX from 'xlsx';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, ArrowDownOutlined, ArrowUpOutlined, FireOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import '../volume.css';
import { useHistory } from 'react-router-dom';

import { ArrowLeftOutlined } from '@material-ui/icons';
const { Title } = Typography;

function VolumeConsumido() {
  const [error, setError] = useState();
  const [lista, setLista] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [loading, setLoading] = useState(21);
  const searchInput = useRef(null);
  const [data, setData] = useState([]);
  const history = useHistory();
  const [datas,setDatas]=useState([]);

  useEffect(() => {
    axios({
      method: 'post',
      url: `${localStorage.getItem('url')}/web/volume_consumido/`,
      headers: { 'Authorization': `token ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      data: { id: 'sds' }
    })
      .then((dat) => {
        if (dat.status !== 200) {
          throw Error('Dados de acesso invalidos');
        }
        return dat;
      })
      .then((d) => {
        console.log(d.data);
        setLoading(null);
        setLista(d.data);
        setData(d.data);
      })
      .catch((e) => {
        setError(e.message);
      });
  }, []);

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => clearFilters && handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({ closeDropdown: false });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
              }}
            >
              Filter
            </Button>
            <Button type="link" size="small" onClick={confirm}>
              Close
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
      onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current.select(), 100);
        }
      },
      render: (text) =>
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        ),
    };
  };

  const DateFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const handleDateChange = (dates) => {
      if (dates && dates.length === 2) {
        
        setSelectedKeys(dates);
        setDatas(dates);
      } else {
        setSelectedKeys([]);
      }
    };

    const handleConfirm = () => {
      if (selectedKeys.length === 2) {
        confirm();
      }
    };

    return (
      <div style={{ padding: 8 }}>
        <Space>
          <DatePicker.RangePicker
            value={selectedKeys}
            onChange={handleDateChange}
            onOk={handleConfirm}
          />
          <Button type="primary" onClick={handleConfirm}>
            Filter
          </Button>
          <Button onClick={() => clearFilters()}>Reset</Button>
        </Space>
      </div>
    );
  };

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Nome do Cliente',
      dataIndex: 'nome',
      key: 'nome',
      ...getColumnSearchProps('nome'),
    },
    {
      title: 'Numero do Contador',
      dataIndex: 'numero_do_contador',
      key: 'numero_do_contador',
    },
    {
      title: 'Bairro',
      dataIndex: 'morada',
      key: 'morada',
      filters: [
        {
          text: 'Aeroporto',
          value: 'Aeroporto',
        },
        {
          text: '25 de Junho',
          value: '25 de Junho',
        },
        {
          text: 'Coop PH5',
          value: 'coop',
        },
        {
          text: 'Coop PH6',
          value: 'coop',
        },
        {
          text: 'Munhuana',
          value: 'Munhuana',
        },
      ],
      onFilter: (value, record) => record.morada.indexOf(value) === 0,
    },
    {
      title: 'Metodo de Pagamento',
      key: 'metodo',
      dataIndex: 'metodo',
      filters: [
        {
          text: 'numerario',
          value: 'numerario',
        },
        {
          text: 'E-mola',
          value: 'emola',
        },
        {
          text: 'M-pesa',
          value: 'Mpesa',
        },
        {
          text: 'RecargaAKI',
          value: 'recargaaki',
        },
      ],
      onFilter: (value, record) => record.metodo.indexOf(value) === 0,
    },
    {
      title: 'm3',
      key: 'metroscubicos',
      dataIndex: 'metroscubicos',
    },
    {
      title: 'Data de Compra',
      key: 'data_de_compra',
      dataIndex: 'data_de_compra',
      filterDropdown: DateFilterDropdown,
      onFilter: (value, record) => {
        const [startDate, endDate] = datas;
        const recordDate = new Date(record.data_de_compra);
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
      
        // Set time to midnight for start and end dates
        startDateObj.setHours(0, 0, 0, 0);
        endDateObj.setHours(0, 0, 0, 0);
      
        return recordDate >= startDateObj && recordDate <= endDateObj;
      },
      filterIcon: (filtered) => (
        <Button type={filtered ? 'primary' : 'default'} shape="circle" icon={<i className="fas fa-filter" />} />
      ),
      render: (date) => moment(date).format('YYYY-MM-DD'),
    },
  ];


  const columns_data = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      render: (text) => <a>{text}</a>,
    },

    {
      title: 'Data de Compra',
      key: 'data_de_compra',
      dataIndex: 'data_de_compra',
      filterDropdown: DateFilterDropdown,
      onFilter: (value, record) => {
        const [startDate, endDate] = datas;
        const recordDate = new Date(record.data_de_compra);
        const startDateObj = new Date(startDate);
        const endDateObj = new Date(endDate);
      
        // Set time to midnight for start and end dates
        startDateObj.setHours(0, 0, 0, 0);
        endDateObj.setHours(0, 0, 0, 0);
      
        return recordDate >= startDateObj && recordDate <= endDateObj;
      },
      filterIcon: (filtered) => (
        <Button type={filtered ? 'primary' : 'default'} shape="circle" icon={<i className="fas fa-filter" />} />
      ),
      render: (date) => moment(date).format('YYYY-MM-DD'),
    },
    {

      title: 'idCliente',
      dataIndex: 'idCliente',
      key: 'idCliente',
    },
    {
      title: 'idContador',
      dataIndex: 'idContador',
      key: 'idContador',
    },
    {
      title: 'Bairro',
      dataIndex: 'morada',
      key: 'morada',
      filters: [
        {
          text: 'Aeroporto',
          value: 'Aeroporto',
        },
        {
          text: '25 de Junho',
          value: '25 de Junho',
        },
        {
          text: 'Coop PH5',
          value: 'coop',
        },
        {
          text: 'Coop PH6',
          value: 'coop',
        },
        {
          text: 'Munhuana',
          value: 'Munhuana',
        },
      ],
      onFilter: (value, record) => record.morada.indexOf(value) === 0,
    },
    {
      title: 'Metodo de Pagamento',
      key: 'metodo',
      dataIndex: 'metodo',
      filters: [
        {
          text: 'numerario',
          value: 'numerario',
        },
        {
          text: 'E-mola',
          value: 'emola',
        },
        {
          text: 'M-pesa',
          value: 'Mpesa',
        },
        {
          text: 'RecargaAKI',
          value: 'recargaaki',
        },
      ],
      onFilter: (value, record) => record.metodo.indexOf(value) === 0,
    },
    {
      title: 'm3',
      key: 'metroscubicos',
      dataIndex: 'metroscubicos',
    },
    {
      title: 'TSC',
      key: 'tsc',
      dataIndex: 'tsc',
      render: (value) => parseFloat(value).toFixed(2),
    },
    {
      title: 'Iva',
      key: 'iva',
      dataIndex: 'iva',
      render: (value) => parseFloat(value).toFixed(2),
    },
  
    {
      title: 'Valor Liquido',
      key: 'valor_pago',
      dataIndex: 'valor_pago',
      render: (value) => parseFloat(value).toFixed(2),
    },
    {
      title: 'Valor Bruto',
      key: 'tsc',
      dataIndex: 'tsc',
    },
  
  ];

  const onChange = (pagination, filters, sorter, extra) => {
    setData(extra.currentDataSource);
  };

  const handleExport = () => {
    const selectedKeys = ['id', 'nome', 'numero_do_contador', 'morada', 'metodo', 'metroscubicos', 'data_de_compra'];
    const filteredData = data.map((item) => {
      const filteredItem = {};
      selectedKeys.forEach((key) => {
        if (item.hasOwnProperty(key)) {
          filteredItem[key] = item[key];
        }
      });
      return filteredItem;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();

    // Add the column names as the first row in the worksheet
    const columnNames = columns.map((column) => column.title);
    XLSX.utils.sheet_add_aoa(worksheet, [columnNames], { origin: 'A1' });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Volume_aquirido.xlsx');
  };

  return (
    <div>
      {localStorage.setItem('location','Volume consumido')}
      {loading && (
        <div className="LoadingScreen">
          <Spin tip="Carregando"  size="large"    />
        </div>
      )}

      {lista && (
        <>
          <Title onClick={()=>{history.push('/admin/home/Relatorios_estatisticos')}} className='volta_' level={3}> <ArrowLeftOutlined/> Volume Consumido</Title>
          
          <div className="totais" style={{ display: 'flex', flexDirection: 'row' }}>
            <Col span={12}>
              <Card bordered={false}>
                <Statistic
                  title="Total Volume Consumido"
                  value={lista[0].metros_total}
                  precision={2}
                  valueStyle={{ color: 'red' }}
                  prefix={<FireOutlined />}
                  suffix="m3"
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card bordered={false}>
                <Statistic
                  title="Numero total de Clientes"
                  value={lista[0].numero_clientes}
                  precision={2}
                  valueStyle={{ color: '#3f8600' }}
                  prefix={<UsergroupAddOutlined />}
                  suffix=""
                />
              </Card>
            </Col>
          </div>

        {/*<Table
            className="tabela-recat-native"
            columns={columns}
            onChange={onChange}
            dataSource={lista}
            pagination={{
              pageSize: 10,
            }}
          /> */}  
            <Table
            className="tabela-recat-native"
            columns={columns_data}
            onChange={onChange}
            dataSource={lista}
            pagination={{
              pageSize: 10,
            }}
          />
          <Button onClick={handleExport}>Export to Excel</Button>
        </>
      )}
    </div>
  );
}

export default VolumeConsumido;
